"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCodeNotDefinedException = void 0;
const ts_error_1 = __importDefault(require("ts-error"));
class CountryCodeNotDefinedException extends ts_error_1.default {
    constructor(tenant) {
        super(`No country code found for "${tenant}" tenant`);
        this.tenant = tenant;
    }
}
exports.CountryCodeNotDefinedException = CountryCodeNotDefinedException;
//# sourceMappingURL=country-code-not-defined.exception.js.map